import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import useUnreadCount from '../hooks/useUnreadCount';

/**
 * Reusable bell icon with unread-count badge.
 * Tapping navigates to /notifications (the inbox).
 * Count comes from the shared useUnreadCount hook so every chip in the app
 * always shows the same number.
 *
 * Props:
 *   variant: 'on-purple' (default, for gradient headers) | 'on-white'
 *   className: extra classes
 */
const NotificationBell = ({ variant = 'on-purple', className = '' }) => {
  const navigate = useNavigate();
  const unread = useUnreadCount();

  const baseStyle = variant === 'on-white'
    ? 'bg-gray-100 hover:bg-gray-200 text-gray-700'
    : 'bg-white/20 hover:bg-white/30 text-white';

  return (
    <button
      onClick={() => navigate('/notifications')}
      className={`relative p-2 rounded-lg transition-colors ${baseStyle} ${className}`}
      data-testid="inbox-bell-btn"
      title="Notifications"
      aria-label="Notifications"
    >
      <Bell className="h-4 w-4" />
      {unread > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 bg-red-500 rounded-full text-[10px] flex items-center justify-center text-white font-bold"
          data-testid="inbox-unread-badge"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;
